/**
 * Created by Alex Aguilar on 7/29/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('structureSeatMapService', structureSeatMapService);

    structureSeatMapService.$inject = ['$http', 'CONFIG', 'messageService'];

    function structureSeatMapService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/structures';

        var service = {
            getStructures: getStructures,
            getPageStructures: getPageStructures,
            getStructure: getStructure,
            getLoadForm: getLoadForm,
            saveStructure: saveStructure,
            updateStructure: updateStructure,
            deleteStructure: deleteStructure,
            getStructureByModelAircraft: getStructureByModelAircraft,
            getAircraftByStructure: getAircraftByStructure,
            getStructuresByModelAircraft: getStructuresByModelAircraft,
            getNumberRowsColumns: getNumberRowsColumns,
            getNumberColumns: getNumberColumns,
            getObjectFormStructure: getObjectFormStructure,
            getSeatOptions: getSeatOptions,
            getCabinClassSeatOption: getCabinClassSeatOption,
            thereNameStructure: thereNameStructure
        }

        return service;

        function getStructures(){
            return $http.get(urlBase + '/list')
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function getPageStructures(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function getStructure(structureId, detailed){
            var params = (detailed != undefined) ? "?detailed=" + detailed : "";
            return $http.get(urlBase + "/" + structureId + params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('structures');
                });
        }

        function getLoadForm(structureId) {
            return $http.get(urlBase + '/loadForm?structureId=' + structureId)
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function saveStructure(structure){
            return $http.post(urlBase, structure)
                .then(function(response){
                    messageService.register('structureSeatMaps');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('structureSeatMaps');
                });
        }

        function updateStructure(structure, structureId){
            return $http.put(urlBase + "/" + structureId, structure)
                .then(function(response){
                    messageService.registerUpdate('structureSeatMaps');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('structureSeatMaps')
                });
        }

        function deleteStructure(structureId){
            return $http.delete(urlBase + "/" + structureId)
                .then(function(response){
                    messageService.registerDelete('structureSeatMaps');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('structureSeatMaps');
                });
        }

        function getStructureByModelAircraft(makerId, modelAircraftId){
            return $http.get(urlBase + "/" + makerId + "/maker/" + modelAircraftId + "/modelAircraft")
                .then(function(response){
                    return response;
                }).catch(function(){
                    messageService.findAllError('');
                });
        }

        function getStructuresByModelAircraft(){
            return $http.get(urlBase + "/modelAircraft")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.structures : [];
                }).catch(function(){
                    messageService.findAllError('');
                });
        }

        function getAircraftByStructure(structureId){
            return $http.get(urlBase + "/" + structureId + "/aircraft")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.aircrafts : [];
                }).catch(function(){
                    messageService.findAllError('');
                });
        }

        function thereNameStructure(name){
            return $http.get(urlBase + "/thereNameStructure/" + name, {headers: {'Loading-Overlay': false}})
        }

        function getNumberRowsColumns() {
            return [
                { id: 3, value: "3" },
                { id: 4, value: "4" },
                { id: 5, value: "5" },
                { id: 6, value: "6" },
                { id: 7, value: "7" },
                { id: 8, value: "8" },
                { id: 9, value: "9" },
                { id: 10, value: "10" },
                { id: 11, value: "11" },
                { id: 12, value: "12" }
            ];
        }

        function getNumberColumns() {
            return [
                { id: 1, value: "1" },
                { id: 2, value: "2" },
                { id: 3, value: "3" },
                { id: 4, value: "4" },
                { id: 5, value: "5" },
                { id: 6, value: "6" },
                { id: 7, value: "7" },
                { id: 8, value: "8" },
                { id: 9, value: "9" },
                { id: 10, value: "10" },
                { id: 11, value: "11" },
                { id: 12, value: "12" },
                { id: 13, value: "13" },
                { id: 14, value: "14" },
                { id: 15, value: "15" },
                { id: 16, value: "16" },
                { id: 17, value: "17" },
                { id: 18, value: "18" },
                { id: 19, value: "19" },
                { id: 20, value: "20" },
                { id: 21, value: "21" },
                { id: 22, value: "22" },
                { id: 23, value: "23" },
                { id: 24, value: "24" },
                { id: 25, value: "25" }
            ];
        }

        function getObjectFormStructure() {
            return {
                modelAircraft: null,
                name: '',
                numberGround: 1,
                template:'',
                twoFloors:false,
                cabins: [
                    {
                        category: "Y",
                        categoryCode: "Y",
                        name: 'string',
                        row: 3,
                        column: 3,
                        rowNum: 3,
                        columnNum: 3,
                        floor: false,
                        width: 0,
                        height: 0,
                        left: 0,
                        top: 0,
                        seats: []
                    }
                ],
                cabinMain: {
                    width: 0,
                    height: 0,
                    left: 0,
                    top: 0,
                    legends: []
                },
                columns: [],
                heights: [],
                widths: [],
                totalHeights: 0,
                totalWidths: 0,
                totalWidthSeatMap:620,
                columnMax: 0,
                widthTotal: 0,
                HeightTotal: 0,
                detailRows: [],
                rowMax: ""

            };
        }

        function getSeatOptions() {
            return {
                economyClass: {
                    width: 37,
                    height: 33,
                    spaceBetweenSeat: 10,
                    headerSeatName: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"]
                },
                firstClass: {
                    width: 40,
                    height: 41,
                    spaceBetweenSeat: 10,
                    headerSeatName: ["I", "J", "K", "L", "M", "N", "O", "P", "S", "T", "U", "V"]
                },
                businessClass: {
                    width: 37,
                    height: 33,
                    spaceBetweenSeat: 10,
                    headerSeatName: ["M", "N", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
                }
            };
        }

        function getCabinClassSeatOption(cabinClass) {
            var cabinClassSeatOptions = getSeatOptions();
            return cabinClassSeatOptions[cabinClass];
        }
    }
})();
